// MA-497 (Journey v3, PR-B / §5 + A12) — the pick-confirmation delight
// signal: "a flying-dot animation arcs toward the Practice tab icon, which
// pulses once." JourneyPath.tsx (the stone) and BottomTabBar.tsx (the tab
// icon) are SIBLING route components, never mounted together — a stone tap
// on /journey cannot reach the tab bar via props. A plain `window`
// CustomEvent is the smallest honest bridge (no new global store, no
// context provider threaded through the whole app for one animation);
// BottomTabBar.tsx is always mounted whenever /journey is (the persistent
// bottom-tab shell), so the listener is always live when the event fires.
//
// Pure/DOM-only — no engine write, no navigation, purely a display cue.

export const JOURNEY_PICK_ADDED_EVENT = "pw:journey-pick-added";

export interface JourneyPickAddedEventDetail {
  /** Viewport-relative center of the tapped stone, the flying dot's START
   *  point. BottomTabBar supplies its own practice-tab-icon rect as the
   *  END point (it owns that element, not this module). */
  x: number;
  y: number;
}

/** Dispatches the event from the tapped stone's own bounding rect. No-op
 *  (never throws) when `window`/`CustomEvent` aren't available (SSR / a
 *  DOM-less test harness) — this is decorative feedback, never load-
 *  bearing for the pick itself (the pick write already happened via
 *  `togglePick` by the time this is called). */
export function dispatchJourneyPickAdded(originRect: { left: number; top: number; width: number; height: number }): void {
  if (typeof window === "undefined" || typeof CustomEvent === "undefined") return;
  try {
    window.dispatchEvent(
      new CustomEvent<JourneyPickAddedEventDetail>(JOURNEY_PICK_ADDED_EVENT, {
        detail: { x: originRect.left + originRect.width / 2, y: originRect.top + originRect.height / 2 },
      }),
    );
  } catch {
    /* decorative only — never block the pick on a dispatch failure */
  }
}
